import { render, staticRenderFns } from "./article3.vue?vue&type=template&id=fef32574&"
import script from "./article3.vue?vue&type=script&lang=js&"
export * from "./article3.vue?vue&type=script&lang=js&"
import style0 from "./article3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports